import { AfterViewInit, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { NotificationsService } from './layout/common/notifications/notifications.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
    providers: [],
})
export class AppComponent implements AfterViewInit {

    constructor(
        private _authService: AuthService,
        private _notificationsService: NotificationsService,
    ) {
      //  window['global'] = window;
    }

    ngAfterViewInit(): void {
        const self = this;
        setTimeout(() => {
            self._authService.authStatus.subscribe((loggedIn) => {
                if (loggedIn) {
                    self._notificationsService.startNotifications();
                } else {
                    self._notificationsService.stopNotifications();
                }
            });

            if (self._authService.isLoggedIn()) {
                self._notificationsService.startNotifications();
            } else {
                self._notificationsService.stopNotifications();
            }
        }, 1500);
            
    }

    ngOnDestroy(): void {
        this._notificationsService.stopNotifications();
    }
}
